module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/blueRightTopBg-3a38b1df8dcc1ca65feb08d4be8be102.png";